let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/event.js?v=129793407935769848231779088362");
  loadScript("https://bridge.shopflo.com/js/shopflo.bundle.js");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/devx-script.js?v=177938574476858711941779088362");  
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/all.min.js?v=155899187558914370431779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/product-form.js?v=56043074768287964941779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/cart-notification.js?v=133508293167896966491779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/search-form.js?v=133129549252120666541779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/quantity-popover.js?v=987015268078116491779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/shop-all.js?v=143197897513113412691779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/quick-add.js?v=73073840428863680991779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/facets.js?v=46295235780883033701779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/show-more.js?v=135784227224860024771779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/st_offers.js?v=149182207220895290631779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/predictive-search.js?v=162273246065392412141779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/dk-internal.js?v=4617053458569228981779088362");

 
  

  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/quantity-popover.css?v=76231206801088522361779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-color-swatch.css?v=44657734777189145271779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/all.min.css?v=36347114306294163891779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-price.css?v=70172745017360139101779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-card.css?v=90531592475021317501779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart.css?v=49529066954642232561779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-mega-menu.css?v=3343104478291901121779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-totals.css?v=59014315448263284001779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart-drawer.css?v=41189841170916328551779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-discounts.css?v=152760482443307489271779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/searchtap.css?v=72127222885983381071779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-list-menu.css?v=151968516119678728991779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-search.css?v=165164710990765432851779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-menu-drawer.css?v=20646116693146970981779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart-notification.css?v=54116361853792938221779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart-items.css?v=47901327362710772261779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-collection-hero.css?v=150137544140055157131779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/quick-add.css?v=66647833350618835731779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-show-more.css?v=139536189637226996221779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-swatch-input.css?v=61683592951238328641779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-swatch.css?v=68619770617697936771779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/cart-drawer-new-ui-extra-css.css?v=104987512365633639361779088362");
   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/details-modal.js?v=119528565511025453401779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/details-disclosure.js?v=13653116266235556501779088362");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
